import { render, staticRenderFns } from "./OverviewItem.vue?vue&type=template&id=3ed145fe"
import script from "./OverviewItem.vue?vue&type=script&lang=ts"
export * from "./OverviewItem.vue?vue&type=script&lang=ts"
import style0 from "./OverviewItem.vue?vue&type=style&index=0&id=3ed145fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports